export default "__VITE_ASSET__BWWSWb0C__"